module.exports = __webpack_public_path__ + "static/img/small-mall.c854d14d.png";